import React from 'react';
import { TableFreights } from '../../components';
import RowHeaderHelp from '../../components/RowHeaderHelp';

const Freights: React.FC = () => {
  return (
    <div className="container-body no-padding">
      <RowHeaderHelp name="Gestão de Fretes" />
      <TableFreights />
    </div>
  );
};

export default Freights;
